module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab1"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Table I: The Family of Antipater.")])]), _vm._v(" "), _c('p', {
    staticClass: "tab"
  }, [_vm._v("A. Sons.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_pix-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tab"
  }, [_vm._v("B. Daughters.")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_pix-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("CAPITALS: Rulers of Macedon (see also "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tab6"
    }
  }, [_vm._v("Table VI")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Order of birth is uncertain.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab2"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Table II: The Family of Antipater’s Eldest Daughter.")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_px-1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab3"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Table III: The Family of Nikaia.")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_px-2.jpg"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab4"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Table IV: The Families of Eurydike and Berenike.")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_pxi.jpg"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab5"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Table V: The Families of Phila.")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_pxii.jpg"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('p', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab6"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Table VI: The Macedonian Kings, 359 – 239.")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img_pxiii.jpg"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-208b872f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_tables.vue
// module id = 75
// module chunks = 0